






























import {Component, Vue, Inject, Prop, Watch} from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import Ajax from "@/lib/ajax";


@Component
export default class MyOrgInfo extends AbpBase {
  @Prop({type: Boolean, default: false}) value: boolean;
  @Prop({type: Number, required: true}) userId: number;

  loading: boolean = false;
  selectOrg = [];
  allOrg = [];

  async save() {

    this.loading = true;
    let response = await Ajax.post("/api/services/app/OrganizationUnitUsers/ChangeOrgUser", {
      userId: this.userId,
      OrgIds: this.selectOrg
    });
    this.loading = false;
    this.$emit("save-success");
    this.$emit("input", false);
  }

  cancel() {

    this.$emit("input", false);
  }

  async visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      await this.loadData();
    }
  }

  async loadData() {
    this.loading = true;
    let response = await Ajax.get("/api/services/app/OrganizationUnitUsers/GetOrgList?userId=" + this.userId);
    let model = response.data.result;
    let a = [];
    if (model.allOrg) {
      a.push(...model.allOrg.map(l => {
        return {key: (l.id).toString(), label: l.displayName};
      }));
    }

    this.allOrg = a;

    this.selectOrg = model.myOrg ? model.myOrg.map(x => x.id.toString()) : [];

    // console.log(this.selectOrg)

    this.loading = false;
  }

  filterMethod(data, query) {


    return data.label.indexOf(query) > -1;


  }

  handleChange(newTargetKeys) {
    this.selectOrg = newTargetKeys;
  }
}
